import { BuildingInfoExpense, GetSimulationBuildingListReq } from '@gateway.Simulation'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { searchInfo } from '../../pages/simulation/simulation-building-search/SimulationBuildingSearch'
import { ErrorMessage } from '../../components/parts'

export interface SimulationBuildingSearchState {
  /** 検索条件 */
  simulationBuildingSearch: GetSimulationBuildingListReq
  /** res */
  simulationBuildingList: BuildingInfoExpense[]
  /** 配分 */
  allocationInfo: {
    simulationYm: string
    procurementNo: string
    subNo: string
    branchCd: string
    expense: string
    expenseSeq: string
    displayStartYear: string
  }
  /** 確定ステータス */
  status: boolean
  /** 優先度切替ステータス */
  priorityStatus: boolean
  /** スクロール位置（横） */
  location: number
  /** スクロール位置（縦） - 業者配分 */
  locationTopAllotmentSheet: number
  /** メッセージ */
  messageInfo: ErrorMessage[]
  /** スキップ明細数 */
  skip: number
  /** 選択物件 */
  target: string
}

const initialState: SimulationBuildingSearchState = {
  simulationBuildingSearch: searchInfo,
  simulationBuildingList: [],
  allocationInfo: {
    simulationYm: '',
    procurementNo: '',
    subNo: '',
    branchCd: '',
    expense: '',
    expenseSeq: '',
    displayStartYear: ''
  },
  status: false,
  priorityStatus: false,
  location: 0,
  locationTopAllotmentSheet: 0,
  messageInfo: [],
  skip: 0,
  target: ''
}

const simulationBuildingSearchSlice = createSlice({
  name: 'simulationbuildingsearch',
  initialState,
  reducers: {
    setSimulationBuildingSearch: (
      state,
      action: PayloadAction<GetSimulationBuildingListReq>
    ) => {
      state.simulationBuildingSearch = action.payload
    },
    setSimulationBuildingList: (
      state,
      action: PayloadAction<BuildingInfoExpense[]>
    ) => {
      state.simulationBuildingList = action.payload
      state.simulationBuildingList = state.simulationBuildingList.map((item) => {
        item.isExpanded = true
        return item
      })
    },
    setAllocationInfo: (
      state,
      action: PayloadAction<SimulationBuildingSearchState['allocationInfo']>
    ) => {
      state.allocationInfo = action.payload
    },
    setStatus: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.status = action.payload
    },
    setPriorityStatus: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.priorityStatus = action.payload
    },
    setLocation: (
      state,
      action: PayloadAction<number>
    ) => {
      state.location = action.payload
    },
    setLocationTopAllotmentSheet: (
      state,
      action: PayloadAction<number>
    ) => {
      state.locationTopAllotmentSheet = action.payload
    },
    setMessageInfo: (
      state,
      action: PayloadAction<ErrorMessage[]>
    ) => {
      state.messageInfo = action.payload
    },
    setSkip: (
      state,
      action: PayloadAction<number>
    ) => {
      state.skip = action.payload
    },
    setTarget: (
      state,
      action: PayloadAction<string>
    ) => {
      state.target = action.payload
    }
  }
})

export const SimulationBuildingSearchActions =
  simulationBuildingSearchSlice.actions
export const SimulationBuildingSearchReducers =
  simulationBuildingSearchSlice.reducer
